import React, { Component } from 'react';
//import { withRouter } from 'react-router-dom'
import { validation as v } from '../../misc/formValidationMethods';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Axios from 'axios';
import _ from '../../misc/i18n';

class OperatorForm extends Component {
  constructor(props) {
    super(props);
    this.state = { login_operatora: '', imie: '', nazwisko: '', email: '', telefon: '', operatorzy: [] };
    // <Input jest niezarządzalnym komponenten React
    if (this.props.match.params.login_operatora !== undefined) {
      this.state.isEdited = true;
    } else {
      this.state.isEdited = false;
    }
    this.state.loginFieldErrorMessage = '';
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
  }

  componentDidMount() {
    // tryb edycji
    if (this.props.match.params.login_operatora !== undefined) {
      let login_operatora = this.props.match.params.login_operatora;
      Axios('/api/login/operator/' + login_operatora)
        .then(response => {
          let row = response.data,
            obj = { isEdited: true, login_operatora: row.login_operatora, imie: row.imie, nazwisko: row.nazwisko, email: row.email, telefon: row.operator_telefon }
          this.setState(obj);
        })
        .catch(err => console.log('ERROR:', err))
    }

    Axios.get('/api/login/operatorzy/').then(response => {
      this.setState({ operatorzy: response.data })
    })
  }



  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    // kiedy wciśniemy przycisk zmiany
    if (this.props.location.pathname === '/login/nowy') {
      let state = { login_operatora: '', imie: '', nazwisko: '', email: '' };
      state.isEdited = false;
      this.setState(state);
    }
  }

  handleEdit = (event) => {
    console.log(this.state);
    event.preventDefault();
    this.form.validateAll();
    // walidacja
    // if password is not changed
    let fields = this.form.state.byId, errorOccured = false,
      history = this.history;
    for (let prop in fields) {
      if (fields[prop].error !== undefined) {
        errorOccured = true;
      }
    }
    // jeżeli nie było błędów wysyłamy PUT do API, żeby dodać nowego operatora
    if (!errorOccured) {
      Axios.post('/api/login/aktualizuj/', this.state)
        .then(response => { history.push('/login'); })
        .catch(err => console.log(err));
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.form.validateAll();
    let history = this.history;
    let fields = this.form.state.byId, errorOccured = false;
    for (let prop in fields) {
      if (fields[prop].error !== undefined) {
        errorOccured = true;
      }
    }
    // check if login is not empty
    if (!this.state.login_operatora.toString().trim().length) {
      this.setState({ loginFieldErrorMessage: 'Login nie może być pusty.', loginFieldErrorClass: 'text-danger' });
      errorOccured = true;
    }
    if (this.state.loginFieldErrorMessage !== '') errorOccured = true;

    // jeżeli nie było błędów wysyłamy POST do API, żeby dodać nowego operatora
    if (!errorOccured) {
      Axios.post('/api/login/dodaj', this.state)
        .then(function (response) { history.push('/login'); })
        .catch(function (error) { console.log(error); });
    }
  };

  loginOnChange = (event) => {
    this.handleChange(event);
    let value = event.target.value,
      that = this;
    if (!value.toString().trim().length) {
      that.setState({ loginFieldErrorMessage: _('Login nie może być pusty'), loginFieldErrorClass: 'text-danger' });
    }
    Axios.get('/api/login/getLogin/' + value)
      .then(function (response) {
        if (response.data === 1) {
          that.setState({ loginFieldErrorMessage: _('Ten login jest już zajęty'), loginFieldErrorClass: 'text-danger' });
        } else {
          that.setState({ loginFieldErrorMessage: '', loginFieldErrorClass: 'text-success' });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  removeApiError = () => {
    this.form.hideError(this.userInput);
  };

  handleChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }

  handleCheckIfEdited() {
    return this.state.isEdited;
  }

  render() {
    const { history } = this.props;
    return <div className="container">
      <Form ref={c => { this.form = c; this.history = history; }} onSubmit={this.state.isEdited ? this.handleEdit : this.handleSubmit}>
        <div className="form-row">
          <div className="col">
            <h1>
              {this.state.isEdited ? _('Edytuj operatora') : _('Zarejestruj się')}
            </h1>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <div className="form-group">
              <label htmlFor="imie">{_('Imię operatora')}</label>
              <Input type="text" value={this.state.imie} className="form-control" name="imie" id="imie" validations={[v.required]} placeholder={_("Podaj swoje imię")} onChange={this.handleChange} />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="nazwisko">{_('Nazwisko operatora')}</label>
              <Input type="text" value={this.state.nazwisko} className="form-control" name="nazwisko" id="nazwisko" validations={[v.required]} placeholder={_("Podaj swoje nazwisko")} onChange={this.handleChange} />
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <div className="form-group">
              <label htmlFor="login_operatora">{_('Twój login')}</label>
              <input readOnly={this.state.isEdited ? 'readonly' : ''} type="text" value={this.state.login_operatora} className="form-control" name="login_operatora" id="login" onChange={this.loginOnChange} placeholder={_("Twój login")} />
              <span className={`form-error is-visible ${this.state.loginFieldErrorClass}`}>{this.state.loginFieldErrorMessage}</span>
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="email">{_('Email operatora')}</label>
              <Input type="text" value={this.state.email} className="form-control" name="email" id="email" validations={[v.required, v.email]} placeholder={_("Podaj swój adres email")} onChange={this.handleChange} />
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col"></div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="telefon">{_('Telefon')}</label>
              <Input type="text" value={this.state.telefon} className="form-control" name="telefon" id="telefon" validations={[]} placeholder={_("Będzie nam łatwiej się Tobą skontaktować")} onChange={this.handleChange} />
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <div className="form-group">
              <label htmlFor="haslo">{_('Hasło')}</label>
              <Input minLength="8" type="password" data-edited={this.state.isEdited} value={this.state.haslo} className="form-control" name="haslo" id="haslo" validations={[v.required, v.isEqual, v.lt, v.gt]} placeholder={_("Wpisz hasło")} onChange={this.handleChange} />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="potwierdz_haslo">{_('Potwierdzenie hasła')}</label>
              <Input minLength="8" type="password" value={this.state.potwierdz_haslo} className="form-control" name="potwierdz_haslo" id="potwierdz_haslo" validations={[v.isEqual]} placeholder={_("Potwierdź hasło")} onChange={this.handleChange} />
            </div>
          </div>
        </div>
        {
          this.state.operatorzy.length === 0 && <>
            <div className="form-row">
              <div className="col">
                <div className="form-group form-check">
                  <input type="checkbox" className="form-check-input" id="adminCheck1" required />
                  <label className="form-check-label" htmlFor="adminCheck1">Oświadczam, że mam uprawnienia do dodawania w imieniu firmy  nowych pracowników do listy nowych operatorów programu
                    CALkulator z uprawnieniami do zamawiania drzwi CAL w imieniu firmy, którą rejestruję w systemie</label>
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="col">
                <div className="form-group form-check">
                  <input type="checkbox" className="form-check-input" id="adminCheck2" required />
                  <label className="form-check-label" htmlFor="adminCheck2">Oświadczam, że mam świadomość odpowiedzialności za zamówienia złożone przez wszystkich uprawnionych operatorów, 
                  również niezablokowanych w odpowiednim czasie pracowników, już w firmie niepracujących, lub przeniesionych na inne stanowisko.  </label>
                </div>
              </div>
            </div>
          </>
        }
        <div className="form-row">
          <div className="col"></div>
          <div className="col">
            <button className="btn btn-success btn-block" type="submit">{_('Zapisz')}</button>
          </div>
          <div className="col"></div>
        </div>


      </Form>
    </div>
  }
}
class OperatorDodajForm extends OperatorForm { }
class OperatorEdytujForm extends OperatorForm { }

//const OperatorFormWithRouter = withRouter(OperatorForm);
export { OperatorDodajForm, OperatorEdytujForm };